<template>
  <div class="user-info-head" @click="editCropper()">
    <img :src="options.img" title="点击上传头像" class="img-circle img-lg" />
    <el-dialog
      :title="title"
      v-model="open"
      width="800px"
      custom-class="avatar-dialog"
      append-to-body
      @opened="modalOpened"
      @close="closeDialog"
    >
      <div class="avatar-dialog__content">
      <el-row>
        <el-col :xs="24" :md="12" :style="{ height: '350px' }" class="avatar-dialog__cropper-col">
          <vue-cropper
            ref="cropper"
            :img="options.img"
            :info="true"
            :autoCrop="options.autoCrop"
            :autoCropWidth="options.autoCropWidth"
            :autoCropHeight="options.autoCropHeight"
            :fixedBox="options.fixedBox"
            :outputType="options.outputType"
            @realTime="realTime"
            v-if="visible"
          />
        </el-col>
        <el-col :xs="24" :md="12" :style="{ height: '350px' }" class="avatar-dialog__preview-col">
          <div class="avatar-upload-preview">
            <img :src="options.previews.url" :style="options.previews.img" />
          </div>
        </el-col>
      </el-row>
      <br />
      <el-row class="avatar-dialog__actions">
        <el-col :lg="2" :md="2">
          <el-upload
            action="#"
            :http-request="requestUpload"
            :show-file-list="false"
            :before-upload="beforeUpload"
          >
            <el-button>
              選択
              <el-icon class="el-icon--right"><Upload /></el-icon>
            </el-button>
          </el-upload>
        </el-col>
        <el-col :lg="{ span: 1, offset: 2 }" :md="2">
          <el-button icon="Plus" @click="changeScale(1)"></el-button>
        </el-col>
        <el-col :lg="{ span: 1, offset: 1 }" :md="2">
          <el-button icon="Minus" @click="changeScale(-1)"></el-button>
        </el-col>
        <el-col :lg="{ span: 1, offset: 1 }" :md="2">
          <el-button icon="RefreshLeft" @click="rotateLeft()"></el-button>
        </el-col>
        <el-col :lg="{ span: 1, offset: 1 }" :md="2">
          <el-button icon="RefreshRight" @click="rotateRight()"></el-button>
        </el-col>
        <el-col :lg="{ span: 2, offset: 6 }" :md="2">
          <el-button type="primary" @click="uploadImg()">送 信</el-button>
        </el-col>
      </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import "vue-cropper/dist/index.css";
import { VueCropper } from "vue-cropper";
import { uploadAvatar } from "@/api/system/user";
import useUserStore from "@/store/modules/user";

const userStore = useUserStore();
const { proxy } = getCurrentInstance();

const open = ref(false);
const visible = ref(false);
const title = ref("プロフィール画像を変更");

const isMobile = () => window.innerWidth <= 768;
const CROP_SIZE_PC = 200;
const CROP_SIZE_MOBILE = 100;

//图片裁剪数据
const options = reactive({
  img: userStore.avatar, // 裁剪图片的地址
  autoCrop: true, // 是否默认生成截图框
  autoCropWidth: 200, // 默认生成截图框宽度
  autoCropHeight: 200, // 默认生成截图框高度
  fixedBox: true, // 固定截图框大小 不允许改变
  outputType: "png", // 默认生成截图为PNG格式
  previews: {} //预览数据
});

/** 编辑头像 */
function editCropper() {
  open.value = true;
}
/** 打开弹出层结束时的回调 */
function modalOpened() {
  const size = isMobile() ? CROP_SIZE_MOBILE : CROP_SIZE_PC;
  options.autoCropWidth = size;
  options.autoCropHeight = size;
  visible.value = true;
}
/** 覆盖默认上传行为 */
function requestUpload() {}
/** 向左旋转 */
function rotateLeft() {
  proxy.$refs.cropper.rotateLeft();
}
/** 向右旋转 */
function rotateRight() {
  proxy.$refs.cropper.rotateRight();
}
/** 图片缩放 */
function changeScale(num) {
  num = num || 1;
  proxy.$refs.cropper.changeScale(num);
}
/** 上传预处理 */
function beforeUpload(file) {
  if (file.type.indexOf("image/") == -1) {
    proxy.$modal.msgError("文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。");
  } else {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      options.img = reader.result;
    };
  }
}
/** 上传图片 */
function uploadImg() {
  proxy.$refs.cropper.getCropBlob(data => {
    let formData = new FormData();
    formData.append("avatarfile", data);
    uploadAvatar(formData).then(response => {
      open.value = false;
      // options.img = import.meta.env.VITE_APP_BASE_API + response.imgUrl;
      options.img = response.imgUrl;
      userStore.avatar = options.img;
      proxy.$modal.msgSuccess(proxy.$t('global.editSuccess'));
      visible.value = false;
    });
  });
}
/** 实时预览 */
function realTime(data) {
  options.previews = data;
}
/** 关闭窗口：清除裁剪区和预览区数据 */
function closeDialog() {
  options.img = userStore.avatar;
  options.previews = {};
  visible.value = false;
}
</script>

<style lang='scss' scoped>
.user-info-head {
  position: relative;
  display: inline-block;
  height: 120px;
}

.user-info-head:hover:after {
  content: "+";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  color: #eee;
  background: rgba(0, 0, 0, 0.5);
  font-size: 24px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: pointer;
  line-height: 110px;
  border-radius: 50%;
}

/* 仅手机端：弹窗内容适配，PC 端不受影响 */
@media (max-width: 768px) {
  .avatar-dialog__content {
    padding-top: 0;
  }
  /* 第一行：强制上下排列，裁剪区在上、预览圆在下，中间留空 */
  .avatar-dialog__content .el-row:first-child {
    display: flex;
    flex-direction: column;
    margin-bottom: 0;
    padding-bottom: 0;
    overflow: visible;
  }
  .avatar-dialog__content .el-row:first-child .el-col {
    max-width: 100%;
  }
  /* 裁剪区：固定高度，溢出裁剪，与下方留出空隙 */
  .avatar-dialog__cropper-col {
    height: 200px !important;
    min-height: 200px;
    max-height: 200px;
    margin-bottom: 20px;
    padding-bottom: 0;
    overflow: hidden;
    flex-shrink: 0;
  }
  .avatar-dialog__cropper-col :deep(.vue-cropper) {
    height: 100% !important;
    min-height: 200px;
    max-height: 200px;
    border-radius: 8px;
  }
  /* 预览圆：不设置位置偏移，自然跟随文档流 */
  .avatar-dialog__preview-col {
    height: auto !important;
    min-height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .avatar-upload-preview {
    width: 100px;
    height: 100px;
  }
  .avatar-dialog__content br {
    display: none;
  }
  .avatar-dialog__content .avatar-dialog__actions {
    margin-top: 16px;
    padding-top: 0;
  }
  .avatar-dialog__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
  }
  .avatar-dialog__actions .el-col {
    flex: none;
  }
  .avatar-dialog__actions .el-upload,
  .avatar-dialog__actions .el-button {
    margin-right: 0;
  }
  .avatar-dialog__actions .el-col:last-child {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .avatar-dialog__actions .el-col:last-child .el-button {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .avatar-dialog__cropper-col {
    height: 175px !important;
    min-height: 175px;
    max-height: 175px;
    margin-bottom: 16px;
  }
  .avatar-dialog__cropper-col :deep(.vue-cropper) {
    min-height: 175px;
    max-height: 175px;
  }
  .avatar-dialog__preview-col {
    min-height: 100px;
  }
  .avatar-upload-preview {
    top: 196px;
    transform: none;
    width: 90px;
    height: 90px;
  }
}
</style>

<!-- 仅手机端：弹窗本体宽度与滚动（append-to-body 需全局样式） -->
<style lang="scss">
@media (max-width: 768px) {
  .el-dialog.avatar-dialog {
    width: 92% !important;
    max-width: 420px;
    margin: 5vh auto !important;
    border-radius: 12px;
    max-height: 88vh;
  }
  .el-dialog.avatar-dialog .el-dialog__header {
    padding: 12px 14px;
  }
  .el-dialog.avatar-dialog .el-dialog__body {
    max-height: calc(88vh - 100px);
    overflow-y: auto;
    padding: 0 14px 14px;
  }
  .el-dialog.avatar-dialog .el-dialog__title {
    font-size: 15px;
  }
}
@media (max-width: 480px) {
  .el-dialog.avatar-dialog {
    width: 94% !important;
    max-width: 380px;
    margin: 4vh auto !important;
  }
  .el-dialog.avatar-dialog .el-dialog__body {
    padding: 0 12px 12px;
  }
}
</style>